import React from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import useExport from '@components/export/useExport';
import { track } from '@utils';
import { CLICK_EXPORT_WIDGET_TRENDS_ALL_METRICS } from '@src/utils/sensor/track';

export const exportConfig = {
  page: { key: 'trends', title: 'Trends Dashboard' },
  sections: [
    { key: 'base', title: '' },
    { key: 'metrics-panel', title: 'Metrics Panel' },
    { key: 'compare-panel', title: 'Compare Filters' },
    {
      key: 'annotations',
      title: 'Annotations',
    },
  ],
};

function ExportChartData() {
  const { triggerDownload } = useExport({ config: exportConfig });
  const handleExportClick = () => {
    track({ event: CLICK_EXPORT_WIDGET_TRENDS_ALL_METRICS });
    triggerDownload();
  };

  return (
    <Button onClick={handleExportClick} icon={<DownloadOutlined />}>
      Export
    </Button>
  );
}

export default ExportChartData;
